export enum InlineBannerTypesEnum {
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  UPSELL = 'upsell',
  NEUTRAL = 'neutral',
}
